import styles from './CommentPage.module.css'
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { LentaItem } from "../LentaPage/components/LentaItem/LentaItem";
import backButton from './../../image/ic_back_button.png'
import { Avatar } from 'antd';
import icSend from './../../image/ic_send.svg'
import icCLose from './../../image/ic_close.png'
import icEditAction from './../../image/ic_edit_action.svg'
import { UserOutlined } from '@ant-design/icons';
import { CommentItem } from './CommentItem';
import { useEffect, useState } from 'react';
import { deleteComment, getComments, sendComment } from '../../store/comment-slice/CommentSlice';
export const CommentPage = ({onClose}:{onClose:()=>void})=>{
    const navigation = useNavigate();
    const dispatch:any = useAppDispatch()
    const [commentText,setCommentText] = useState("") 
    const [editId,setEditId] = useState<number|null>(null)
    const [oldMsg,setOldMsg] = useState("")
    const itemList = useAppSelector(state=>state.lentaStore.commentStory)
    const comments=useAppSelector(state=>state.commentStore.comments);

    useEffect(()=>{
        if(itemList==null)return;
        dispatch(getComments(itemList.story_id))
    },[itemList])

    useEffect(()=>{
        setEditItem(null)
    },[comments])

    const setEditItem=(editId:number|null)=>{
        if(editId==null){
            setEditId(null);
            setCommentText("")
            setOldMsg("")
            return
        }
        setEditId(editId)
        const msg = comments.find((item)=>item.c_id===editId)?.message
        if(msg!=null){
            setCommentText(msg)
            setOldMsg(msg)
        }
    }
    return(
        <div>
            <div className={styles.comment_page_container}>
            <div style={{position:"fixed", left:"10px", top:"10px", zIndex:"999"}}>
                <div className={styles.back_button_container}>
                    <span onClick={()=>{onClose()}} style={{cursor:"pointer"}}>
                        <img src={backButton}/>
                    </span>
                </div>
            </div>
            {itemList!=null&&<LentaItem 
                                    act_type={itemList.act_type}
                                    uId={itemList.u_id}
                                    photo={itemList.photo}
                                    image={itemList.images}
                                    name={itemList.user_name} 
                                    distance={itemList.distance}
                                    time={itemList.time}
                                    distance_day={itemList.distance_day}
                                    commentButtonDisplay={false}
                                    contComment={0}
                                    reactions={[]}/>}
            <div style={{textAlign:"center"}}>
                <div className={styles.comment_page_item_title}>
                    Комментарии
                </div>
            </div>
            {comments.map((item)=>{
                return <CommentItem 
                isEdit={item.is_edit}
                uName={item.user_name} 
                uMsg={item.message} 
                msgDate={item.message_date}
                onChange={()=>{setEditItem(item.c_id)}}
                onDelete={()=>{dispatch(deleteComment(itemList?.story_id!=null?itemList?.story_id:null,item))}}/>
            })}
            
            
        </div>
            <div className={styles.comment_page_input_bottom}>
                {editId&&<div className={styles.comment_page_change_container}>
                    <div className={styles.comment_page_change_body}>
                        <div className={styles.comment_page_item_body_title}>
                            Редактирование
                        </div>
                        <div style={{maxLines:"1"}}>{oldMsg}</div>
                    </div>
                    <img src={icCLose} style={{marginRight:"10px"}} onClick={()=>{setEditItem(null)}}/>
                </div>}
                <div className={styles.comment_page_input_container}>
                    <Avatar size={32} icon={<UserOutlined/>}/>
                    <textarea name='commentText' 
                    className={styles.comment_page_input} 
                    value={commentText} 
                    onChange={(e)=>setCommentText(e.target.value)}/>
                    {editId==null&&<div style={{marginRight:"20px", cursor:"pointer"}} onClick={()=>{dispatch(sendComment(itemList?.story_id!=null?itemList?.story_id:null,commentText,null))}}>
                        <img src={icSend}/>
                    </div>}
                    {editId!=null&&<div style={{marginRight:"20px", cursor:"pointer"}} onClick={()=>{dispatch(sendComment(itemList?.story_id!=null?itemList?.story_id:null,commentText,editId))}}>
                        <img src={icEditAction}/>
                    </div>}
                </div>
            </div>
        </div>
    )
}